import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgWarningFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M2.677 23h18.674a2.609 2.609 0 0 0 1.246-.328c.384-.213.71-.518.952-.89s.392-.8.437-1.245a2.818 2.818 0 0 0-.18-1.31L14.334 2.415a2.71 2.71 0 0 0-.98-1.036 2.611 2.611 0 0 0-2.71 0 2.71 2.71 0 0 0-.979 1.036l-9.47 16.81a2.817 2.817 0 0 0 .221 2.507c.229.369.54.677.907.897.368.22.781.348 1.206.37h.147ZM10.8 9.556c0-.675.537-1.223 1.2-1.223.663 0 1.2.548 1.2 1.223V12c0 .675-.537 1.222-1.2 1.222-.663 0-1.2-.547-1.2-1.222V9.556ZM12 18.11c.663 0 1.2-.547 1.2-1.222 0-.675-.537-1.222-1.2-1.222-.663 0-1.2.547-1.2 1.222 0 .675.537 1.222 1.2 1.222Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgWarningFilled);
export default ForwardRef;
